var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPersonBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1839_2714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5004 10.6966C9.73808 10.6966 8.30469 9.2373 8.30469 7.44304C8.30469 5.64878 9.73808 4.18945 11.5004 4.18945C13.2628 4.18945 14.6962 5.64878 14.6962 7.44304C14.6962 9.2373 13.2628 10.6966 11.5004 10.6966ZM11.5004 5.86409C10.6451 5.86409 9.94956 6.57223 9.94956 7.44304C9.94956 8.31386 10.6451 9.02199 11.5004 9.02199C12.3558 9.02199 13.0513 8.31386 13.0513 7.44304C13.0513 6.57223 12.3558 5.86409 11.5004 5.86409Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6521 14.9615C15.1986 14.9615 14.8296 14.5859 14.8296 14.1242C14.8296 12.2557 13.3352 10.7342 11.5 10.7342C9.66474 10.7342 8.17026 12.2557 8.17026 14.1242C8.17026 14.5859 7.80134 14.9615 7.34783 14.9615C6.89431 14.9615 6.52539 14.5859 6.52539 14.1242C6.52539 11.3323 8.75772 9.05957 11.5 9.05957C14.2422 9.05957 16.4745 11.3323 16.4745 14.1242C16.4745 14.5859 16.1056 14.9615 15.6521 14.9615Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21C11.2815 21 11.0723 20.9115 10.9196 20.7536L8.78831 18.5837H2.00909C0.902329 18.5837 0 17.6675 0 16.5383V2.04545C0 0.916268 0.89998 0 2.00909 0H20.9909C22.0977 0 23 0.916268 23 2.04545V16.5407C23 17.6675 22.1 18.5861 20.9909 18.5861H14.214L12.0828 20.756C11.9277 20.9139 11.7185 21.0024 11.5023 21.0024L11.5 21ZM2.00909 1.67464C1.80936 1.67464 1.64487 1.83971 1.64487 2.04545V16.5407C1.64487 16.744 1.80701 16.9115 2.00909 16.9115H9.12669C9.34522 16.9115 9.55435 17 9.70709 17.1579L11.4977 18.9809L13.2882 17.1579C13.4433 17 13.6524 16.9115 13.8686 16.9115H20.9862C21.1859 16.9115 21.3504 16.7464 21.3504 16.5407V2.04545C21.3504 1.84211 21.1883 1.67464 20.9862 1.67464H2.00909Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1839_2714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonBox);
export default __webpack_public_path__ + "static/media/icon_person_box.f1e59b7f98850844d3f608e474062c47.svg";
export { ForwardRef as ReactComponent };